module.exports = __webpack_public_path__ + "static/media/17805.f642bb67.jpg";